module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [_c('h2', [_vm._v("RUT-avdrag")]), _vm._v(" "), _c('p', [_vm._v("Genom att ange ditt personnummer nedan kan du få RUT-avdrag för denna tjänst.")]), _vm._v(" "), _c('p', [_vm._v("Ange 12 siffror i formatet ÅÅÅÅMMDD-XXXX. "), (_vm.isSwedish) ? _c('span', {
    staticClass: "bold"
  }, [_vm._v("För att kunna ansöka om RUT krävs att du betalar skatt i Sverige.")]) : _vm._e()]), _vm._v(" "), (!_vm.isSwedish) ? _c('p', {
    staticClass: "bold"
  }, [_vm._v("Det verkar som att du inte bokar från Sverige - för att kunna ansöka om RUT krävs att du betalar skatt i Sverige.")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("För att kunna nyttja RUT-avdrag krävs att "), _c('b', [_vm._v("städningen utförs samma år som betalning genomförs")]), _vm._v(". I annat fall finns risk för avslag hos Skatteverket. Det går bra att lägga till i efterhand via Mina sidor eller genom att ringa oss på "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054‑13 26 00")]), _vm._v(".")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssn),
      expression: "ssn"
    }],
    class: {
      error: _vm.error
    },
    attrs: {
      "placeholder": "ÅÅÅÅMMDD-XXXX",
      "type": "text"
    },
    domProps: {
      "value": (_vm.ssn)
    },
    on: {
      "keydown": function($event) {
        _vm.error = ''
      },
      "keyup": _vm.addDash,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssn = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.error) ? _c('div', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error-text"
  }, [_c('br'), _vm._v(_vm._s(_vm.error)), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "small",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.click
    }
  }, [_vm._v("Välj rutavdrag")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Jag vill inte ha rutavdrag")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca91c854"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/RutModal.vue
// module id = 1005
// module chunks = 0